import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { selectAllStrings } from '../features/language/languageSlice';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import '../stylesheets/ErrorModal.css';

const ErrorModal = ({title='', message, onClose}) => {
    const strings = useSelector(selectAllStrings);
    const history = useHistory();
    
    return (<div className="modal" id="error_modal">
        <div className="modal-body" id="error_modal_body">
            <div className="modal-content">
                <div className="modal-header">
                    <span>{strings.error}</span>
                    <hr/>
                </div>
                <div className="icon">
                    <FontAwesomeIcon icon={faExclamationCircle}/>
                </div>
                <div className="modal-title">{title ? title : strings.something_went_wrong}</div>
                <div className="modal-text">{message}</div>
                <button className="btn" id="close_button" onClick={event => {
                event.preventDefault();
                onClose();
            }}>{strings.back}</button>
    
            </div>
        </div>
    </div>);
};

export default ErrorModal;